<script setup lang="ts">
import { computed } from 'vue'
import { toolkitUrls } from '@/util/links'

const props = defineProps<{ uuid: string }>()

const editStrategyUrl = computed(() => toolkitUrls.editorLinks.editStrategy(props.uuid))
</script>

<template>
  <a
    :href="editStrategyUrl"
    class="inline-block whitespace-nowrap rounded-xs border border-gray-400 bg-white px-3 py-1.5 text-center align-middle text-text-md font-regular leading-[1.42857143] text-gray-900 no-underline hover:border-gray-500 hover:bg-gray-300 hover:text-gray-900 focus:border-[var(--gray-strong)] focus:bg-gray-300"
  >
    <span class="material-icons-round align-[-2px] text-md leading-[14px]" aria-hidden="true">edit</span>
    Edit
  </a>
</template>
